import React from 'react'

import Section from '../Section'
import { Row, Col } from 'components/Layout'
import Markdown from 'features/Markdown'

import cn from 'classnames'
import s from './Col3Text.scss'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={props.paddingTop}
    paddingBottom={props.paddingBottom}
  >
    <h2 className={sText.heading2}>{props.title}</h2>
    <div className={sText.divider} />
    <Markdown style={{ maxWidth: '700px' }} text={props.body} color={props.color} />
    <br />
    <Row className={cn(sLay['layout-row'], sLay['layout-wrap'])}>
      {props.items.map((item, idx) => (
        <Col className={cn(s.item, sLay['flex-xs-100'], sLay['flex-gt-xs-33'])} key={idx}>
          <div className={sText.descrip2}>{item.title}</div>
          <div className={sText.descrip4}>{item.body}</div>
        </Col>
      ))}
    </Row>
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col3Text/Col3Text.jsx